import { decodeToken } from '../../../utils/jwt';
import useRouter from '../../../utils/useRouter';

export const useLicenceIdFromUrl = () => {
	const {
		match: {
			location: { query },
		},
	} = useRouter();
	const token = query.data;
	let licenceIdFromToken: string | undefined;
	try {
		licenceIdFromToken = token && decodeToken(token).licenceId;
	} catch {
		licenceIdFromToken = undefined;
	}
	return Number.parseInt(licenceIdFromToken || query.licenceId || '132');
};
